import { Directive, TemplateRef, Component, ViewEncapsulation, ElementRef, ContentChild, HostBinding, EventEmitter, Renderer2, ChangeDetectorRef, Input, Output, ViewChild, ContentChildren, NgModule } from '@angular/core';
import { Subject, BehaviorSubject, fromEvent, timer, interval } from 'rxjs';
import { takeUntil, filter, distinctUntilChanged, skip, debounceTime, startWith } from 'rxjs/operators';
import { animationFrame } from 'rxjs/internal/scheduler/animationFrame';
import { DomSanitizer, HammerGestureConfig, HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import 'hammerjs';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/lazy-render.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/platform-browser';
import * as ɵngcc2 from '@angular/common';

function CarouselItemComponent_ng_container_0_ng_template_1_Template(rf, ctx) { }
function CarouselItemComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, CarouselItemComponent_ng_container_0_ng_template_1_Template, 0, 0, "ng-template", 1);
    ɵngcc0.ɵɵprojection(2);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r0.lazyContent && ctx_r0.lazyContent.content);
} }
const _c0 = ["*"];
const _c1 = ["track"];
function CarouselComponent_div_3_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div");
    ɵngcc0.ɵɵpipe(1, "async");
} if (rf & 2) {
    const i_r5 = ctx.index;
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵclassProp("active", i_r5 === ɵngcc0.ɵɵpipeBind1(1, 2, ctx_r3.active$));
} }
function CarouselComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 4);
    ɵngcc0.ɵɵtemplate(1, CarouselComponent_div_3_div_1_Template, 2, 4, "div", 5);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.items);
} }
function CarouselComponent_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
const _c2 = function (a0) { return { $implicit: a0 }; };
class LazyRenderDirective {
    /**
     * @param {?} content
     */
    constructor(content) {
        this.content = content;
    }
}
LazyRenderDirective.ɵfac = function LazyRenderDirective_Factory(t) { return new (t || LazyRenderDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef)); };
LazyRenderDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: LazyRenderDirective, selectors: [["", "lazyRender", ""]] });
/** @nocollapse */
LazyRenderDirective.ctorParameters = () => [
    { type: TemplateRef }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LazyRenderDirective, [{
        type: Directive,
        args: [{
                selector: '[lazyRender]'
            }]
    }], function () { return [{ type: ɵngcc0.TemplateRef }]; }, null); })();
if (false) {
    /** @type {?} */
    LazyRenderDirective.prototype.content;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/carousel-item/carousel-item.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CarouselItemComponent {
    /**
     * @param {?} elRef
     * @param {?} parent
     * @param {?} sanitizer
     */
    constructor(elRef, parent, sanitizer) {
        this.elRef = elRef;
        this.parent = parent;
        this.sanitizer = sanitizer;
        this.rendered = false;
        this.destroy$ = new Subject();
    }
    /**
     * @return {?}
     */
    get style() {
        const { width } = this.parent;
        return this.sanitizer.bypassSecurityTrustStyle(`
      width: ${width}px;
    `);
    }
    /**
     * @return {?}
     */
    get isLazyRender() {
        return !!this.lazyContent;
    }
    /**
     * @return {?}
     */
    ngOnInit() { }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        setTimeout((/**
         * @return {?}
         */
        () => {
            this.parent.active$.pipe(takeUntil(this.destroy$)).subscribe((/**
             * @param {?} res
             * @return {?}
             */
            res => {
                this.rendered = this.rendered || this.index === res;
            }));
        }), 0);
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
CarouselItemComponent.ɵfac = function CarouselItemComponent_Factory(t) { return new (t || CarouselItemComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(CarouselComponent), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.DomSanitizer)); };
CarouselItemComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CarouselItemComponent, selectors: [["ngx-carousel-item"]], contentQueries: function CarouselItemComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, LazyRenderDirective, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.lazyContent = _t.first);
    } }, hostVars: 4, hostBindings: function CarouselItemComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵstyleMap(ctx.style);
        ɵngcc0.ɵɵclassProp("ngx-carousel__item", true);
    } }, ngContentSelectors: _c0, decls: 1, vars: 1, consts: [[4, "ngIf"], [3, "ngTemplateOutlet"]], template: function CarouselItemComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, CarouselItemComponent_ng_container_0_Template, 3, 1, "ng-container", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", !ctx.isLazyRender || ctx.rendered);
    } }, directives: [ɵngcc2.NgIf, ɵngcc2.NgTemplateOutlet], styles: [".ngx-carousel__item{display:inline-block;vertical-align:top}.ngx-carousel__item.pre-mirror-node{position:absolute;left:0;transform:translateX(-100%)}.ngx-carousel__item.post-mirror-node{position:absolute;right:0;transform:translateX(100%)}"], encapsulation: 2 });
/** @nocollapse */
CarouselItemComponent.ctorParameters = () => [
    { type: ElementRef },
    { type: CarouselComponent },
    { type: DomSanitizer }
];
CarouselItemComponent.propDecorators = {
    lazyContent: [{ type: ContentChild, args: [LazyRenderDirective, { static: false },] }],
    style: [{ type: HostBinding, args: ['style',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CarouselItemComponent, [{
        type: Component,
        args: [{
                selector: 'ngx-carousel-item',
                template: "<ng-container *ngIf=\"!isLazyRender || rendered\">\n  <ng-template [ngTemplateOutlet]=\"lazyContent && lazyContent.content\"></ng-template>\n  <ng-content></ng-content>\n</ng-container>\n",
                encapsulation: ViewEncapsulation.None,
                host: {
                    '[class.ngx-carousel__item]': `true`
                },
                styles: [".ngx-carousel__item{display:inline-block;vertical-align:top}.ngx-carousel__item.pre-mirror-node{position:absolute;left:0;transform:translateX(-100%)}.ngx-carousel__item.post-mirror-node{position:absolute;right:0;transform:translateX(100%)}"]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: CarouselComponent }, { type: ɵngcc1.DomSanitizer }]; }, { style: [{
            type: HostBinding,
            args: ['style']
        }], lazyContent: [{
            type: ContentChild,
            args: [LazyRenderDirective, { static: false }]
        }] }); })();
if (false) {
    /** @type {?} */
    CarouselItemComponent.prototype.lazyContent;
    /** @type {?} */
    CarouselItemComponent.prototype.index;
    /** @type {?} */
    CarouselItemComponent.prototype.rendered;
    /**
     * @type {?}
     * @private
     */
    CarouselItemComponent.prototype.destroy$;
    /** @type {?} */
    CarouselItemComponent.prototype.elRef;
    /**
     * @type {?}
     * @private
     */
    CarouselItemComponent.prototype.parent;
    /**
     * @type {?}
     * @private
     */
    CarouselItemComponent.prototype.sanitizer;
}

/**
 * @fileoverview added by tsickle
 * Generated from: utils.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} value
 * @param {?} min
 * @param {?} max
 * @return {?}
 */
function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/carousel/carousel.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CarouselComponent {
    // 后镜像节点
    /**
     * @param {?} render
     * @param {?} hostElRef
     * @param {?} cdr
     */
    constructor(render, hostElRef, cdr) {
        this.render = render;
        this.hostElRef = hostElRef;
        this.cdr = cdr;
        /**
         * 是否开启无缝模式
         */
        this.loop = false;
        /**
         * 切换速度（ms）
         */
        this.speed = 300;
        /**
         * 自动轮播时间间隔，0 代表关闭自动轮播
         */
        this.autoplay = 0;
        /**
         * 是否跟随手指滑动
         */
        this.followFinger = true;
        /**
         * 是否允许手动滑动，设为 false 代表只能通过 api 翻页
         */
        this.allowTouchMove = true;
        /**
         * 默认激活项
         */
        this.initialIndex = 0;
        /**
         * 索引变动时触发
         */
        this.change = new EventEmitter();
        this.active$ = new BehaviorSubject(null);
        this.destroy$ = new Subject();
        this.percent = 0; // 手指滑动距离所占宽度总和百分比
        // 手指滑动距离所占宽度总和百分比
        this.offset = 0; // 偏移量（%）
        // 偏移量（%）
        this.animating = false; // 是否处于过渡效果中
    }
    /**
     * @return {?}
     */
    get count() {
        return this.items.length;
    }
    /**
     * @return {?}
     */
    get width() {
        return this.hostElRef.nativeElement.offsetWidth;
    }
    /**
     * @return {?}
     */
    get canMove() {
        return this.allowTouchMove && !this.animating;
    }
    /**
     * @return {?}
     */
    get data() {
        return {
            active: this.active$.value,
            count: this.count,
            offset: this.offset,
            animating: this.animating
        };
    }
    /**
     * @return {?}
     */
    ngOnInit() { }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        this.active$
            .pipe(takeUntil(this.destroy$), filter((/**
         * @param {?} v
         * @return {?}
         */
        v => v !== null && v >= 0 && v <= this.count - 1)), distinctUntilChanged(), skip(1))
            .subscribe((/**
         * @param {?} res
         * @return {?}
         */
        res => {
            this.change.emit(res);
        }));
        fromEvent(window, 'resize')
            .pipe(takeUntil(this.destroy$), debounceTime(60, animationFrame))
            .subscribe((/**
         * @return {?}
         */
        () => {
            this.resize();
        }));
        this.items.changes
            .pipe(takeUntil(this.destroy$), startWith(null), debounceTime(60, animationFrame))
            .subscribe((/**
         * @return {?}
         */
        () => {
            this.init();
        }));
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) { }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
    /**
     * @param {?} e
     * @return {?}
     */
    onPanStart(e) {
        this.stopAutoplay();
    }
    /**
     * @param {?} e
     * @return {?}
     */
    onPanMove(e) {
        if (!this.canMove) {
            return;
        }
        /** @type {?} */
        const deltaX = this.getSafeDeltaX(e.deltaX);
        this.percent = ((100 / this.count) * deltaX) / this.width;
        if (this.followFinger) {
            /** @type {?} */
            const offset = this.percent - (100 / this.count) * this.active$.value;
            this.move(offset, true);
        }
    }
    /**
     * @param {?} e
     * @return {?}
     */
    onPanEnd(e) {
        if (!this.canMove) {
            return;
        }
        // 轻拂或者滑动距离大于等于一个节点宽度的 50% 才进行跳转
        /** @type {?} */
        let newActive = this.active$.value;
        /** @type {?} */
        const isSwipeLeft = e.direction === Hammer.DIRECTION_LEFT && e.velocityX < -0.3;
        /** @type {?} */
        const isSwipeRight = e.direction === Hammer.DIRECTION_RIGHT && e.velocityX > 0.3;
        if (isSwipeLeft || this.percent <= -50 / this.count) {
            newActive++;
        }
        else if (isSwipeRight || this.percent >= 50 / this.count) {
            newActive--;
        }
        this.goTo(newActive);
        this.startAutoplay();
    }
    /**
     * 跳转到某一项
     * @param {?=} target 目标索引
     * @param {?=} immediate 跳转时是否不显示动画
     * @return {?}
     */
    goTo(target = 0, immediate = false) {
        if (this.animating) {
            return;
        }
        /** @type {?} */
        const active = this.getSafeActive(target);
        /** @type {?} */
        const realActive = this.getRealActive(active);
        this.active$.next(realActive);
        // 到达第一个或最后一个时更新镜像节点
        if (this.loop && (realActive === 0 || realActive === this.count - 1)) {
            this.handleMirrorNodes();
        }
        this.animating = true;
        this.move(-(100 / this.count) * active, immediate).subscribe((/**
         * @return {?}
         */
        () => {
            this.animating = false;
            if (active === -1 || active === this.count) {
                this.goTo(realActive, true);
            }
        }));
    }
    /**
     * 切换到上一个
     * @return {?}
     */
    prev() {
        this.goTo(this.active$.value - 1);
    }
    /**
     * 切换到下一个
     * @return {?}
     */
    next() {
        this.goTo(this.active$.value + 1);
    }
    /**
     * 重新计算更新组件
     * @return {?}
     */
    resize() {
        this.cdr.detectChanges();
    }
    /**
     * @private
     * @return {?}
     */
    init() {
        if (this.items.length === 0) {
            return;
        }
        this.items.forEach((/**
         * @param {?} el
         * @param {?} index
         * @return {?}
         */
        (el, index) => (el.index = index)));
        if (this.loop) {
            this.handleMirrorNodes();
        }
        setTimeout((/**
         * @return {?}
         */
        () => {
            this.goTo(this.getSafeActive(this.initialIndex, true), true);
        }), 0);
        this.startAutoplay();
    }
    /**
     * @private
     * @param {?} deltaX
     * @return {?}
     */
    getSafeDeltaX(deltaX) {
        return clamp(deltaX, -this.width, this.width);
    }
    /**
     * @private
     * @param {?} active
     * @param {?=} strict
     * @return {?}
     */
    getSafeActive(active, strict = false) {
        /** @type {?} */
        const min = this.loop && !strict ? -1 : 0;
        /** @type {?} */
        const max = this.loop && !strict ? this.count : this.count - 1;
        return clamp(active, min, max);
    }
    // 计算真实索引
    // 由于 loop 模式下拷贝了俩节点，所以 active 有误差
    // 假设有三个节点，那么 active 非 loop 模式下为 0 ～ 2，loop 模式下为 -1 ～ 3
    /**
     * @private
     * @param {?} active
     * @return {?}
     */
    getRealActive(active) {
        return (active + this.count) % this.count;
    }
    // loop 模式下首尾拷贝一个节点，模拟无缝轮播
    // 0 1 2 => 2 0 1 2 0
    // TODO: 也许能找到一个不用手动复制 dom，并且可以自动更新内容的方式
    /**
     * @private
     * @return {?}
     */
    handleMirrorNodes() {
        /** @type {?} */
        const trackEl = this.track.nativeElement
        // 清理镜像节点
        ;
        // 清理镜像节点
        try {
            this.render.removeChild(trackEl, this.preMirrorNode);
            this.render.removeChild(trackEl, this.postMirrorNode);
        }
        catch (e) { }
        const { first, last } = this.items;
        this.preMirrorNode = last.elRef.nativeElement.cloneNode(true);
        this.postMirrorNode = first.elRef.nativeElement.cloneNode(true);
        this.render.addClass(this.preMirrorNode, 'pre-mirror-node');
        this.render.addClass(this.postMirrorNode, 'post-mirror-node');
        this.render.insertBefore(trackEl, this.preMirrorNode, first.elRef.nativeElement);
        this.render.appendChild(trackEl, this.postMirrorNode);
    }
    /**
     * @private
     * @param {?} offset
     * @param {?=} immediate
     * @return {?}
     */
    move(offset, immediate = false) {
        /** @type {?} */
        const el = this.track.nativeElement;
        /** @type {?} */
        const oldOffset = this.offset;
        /** @type {?} */
        const newOffset = (this.offset = offset);
        this.render.setStyle(el, 'transition', immediate ? 'none' : `transform ${this.speed}ms`);
        this.render.setStyle(el, 'transform', `translate3d(${offset}%, 0, 0)`);
        return timer(immediate || newOffset === oldOffset ? 0 : this.speed).pipe(takeUntil(this.destroy$));
    }
    /**
     * @private
     * @return {?}
     */
    startAutoplay() {
        if (!this.autoplay || this.count <= 1) {
            return;
        }
        this.stopAutoplay();
        this.intervalSub = interval(this.autoplay + this.speed)
            .pipe(takeUntil(this.destroy$))
            .subscribe((/**
         * @return {?}
         */
        () => {
            /** @type {?} */
            const oldActive = this.active$.value;
            /** @type {?} */
            const newActive = this.loop ? oldActive + 1 : this.getRealActive(oldActive + 1);
            this.goTo(newActive);
        }));
    }
    /**
     * @private
     * @return {?}
     */
    stopAutoplay() {
        this.intervalSub && this.intervalSub.unsubscribe();
    }
}
CarouselComponent.ɵfac = function CarouselComponent_Factory(t) { return new (t || CarouselComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
CarouselComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CarouselComponent, selectors: [["ngx-carousel"]], contentQueries: function CarouselComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, CarouselItemComponent, 4);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.items = _t);
    } }, viewQuery: function CarouselComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c1, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.track = _t.first);
    } }, hostVars: 2, hostBindings: function CarouselComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("ngx-carousel", true);
    } }, inputs: { loop: "loop", speed: "speed", autoplay: "autoplay", followFinger: "followFinger", allowTouchMove: "allowTouchMove", initialIndex: "initialIndex", indicator: "indicator" }, outputs: { change: "change" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], ngContentSelectors: _c0, decls: 5, vars: 5, consts: [[1, "ngx-carousel__track", 3, "dragstart", "panstart", "panmove", "panend", "pancancel"], ["track", ""], ["class", "ngx-carousel__indicator", 4, "ngIf"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "ngx-carousel__indicator"], [3, "active", 4, "ngFor", "ngForOf"]], template: function CarouselComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0, 1);
        ɵngcc0.ɵɵlistener("dragstart", function CarouselComponent_Template_div_dragstart_0_listener($event) { return $event.preventDefault(); })("panstart", function CarouselComponent_Template_div_panstart_0_listener($event) { return ctx.onPanStart($event); })("panmove", function CarouselComponent_Template_div_panmove_0_listener($event) { return ctx.onPanMove($event); })("panend", function CarouselComponent_Template_div_panend_0_listener($event) { return ctx.onPanEnd($event); })("pancancel", function CarouselComponent_Template_div_pancancel_0_listener($event) { return ctx.onPanEnd($event); });
        ɵngcc0.ɵɵprojection(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(3, CarouselComponent_div_3_Template, 2, 1, "div", 2);
        ɵngcc0.ɵɵtemplate(4, CarouselComponent_ng_container_4_Template, 1, 0, "ng-container", 3);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.indicator);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx.indicator)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(3, _c2, ctx.data));
    } }, directives: [ɵngcc2.NgIf, ɵngcc2.NgTemplateOutlet, ɵngcc2.NgForOf], pipes: [ɵngcc2.AsyncPipe], styles: [".ngx-carousel{position:relative;display:block;overflow:hidden}.ngx-carousel__track{position:relative;display:inline-block;white-space:nowrap}.ngx-carousel__indicator{position:absolute;bottom:10px;width:100%;text-align:center;white-space:nowrap;font-size:0;pointer-events:none}.ngx-carousel__indicator div{display:inline-block;width:6px;height:6px;margin:0 3px;border-radius:50%;background:rgba(0,0,0,.25);pointer-events:auto}.ngx-carousel__indicator div.active{background:rgba(0,0,0,.75)}"], encapsulation: 2 });
/** @nocollapse */
CarouselComponent.ctorParameters = () => [
    { type: Renderer2 },
    { type: ElementRef },
    { type: ChangeDetectorRef }
];
CarouselComponent.propDecorators = {
    loop: [{ type: Input }],
    speed: [{ type: Input }],
    autoplay: [{ type: Input }],
    followFinger: [{ type: Input }],
    allowTouchMove: [{ type: Input }],
    indicator: [{ type: Input }],
    initialIndex: [{ type: Input }],
    change: [{ type: Output }],
    track: [{ type: ViewChild, args: ['track', { static: false },] }],
    items: [{ type: ContentChildren, args: [CarouselItemComponent,] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CarouselComponent, [{
        type: Component,
        args: [{
                selector: 'ngx-carousel',
                template: "<div\n  class=\"ngx-carousel__track\"\n  #track\n  (dragstart)=\"$event.preventDefault()\"\n  (panstart)=\"onPanStart($event)\"\n  (panmove)=\"onPanMove($event)\"\n  (panend)=\"onPanEnd($event)\"\n  (pancancel)=\"onPanEnd($event)\"\n>\n  <ng-content></ng-content>\n</div>\n\n<div class=\"ngx-carousel__indicator\" *ngIf=\"!indicator\">\n  <div\n    *ngFor=\"let item of items; let i = index\"\n    [class.active]=\"i === (active$ | async)\"\n  ></div>\n</div>\n\n<ng-container *ngTemplateOutlet=\"indicator; context: { $implicit: data }\"></ng-container>\n",
                encapsulation: ViewEncapsulation.None,
                host: {
                    '[class.ngx-carousel]': `true`
                },
                styles: [".ngx-carousel{position:relative;display:block;overflow:hidden}.ngx-carousel__track{position:relative;display:inline-block;white-space:nowrap}.ngx-carousel__indicator{position:absolute;bottom:10px;width:100%;text-align:center;white-space:nowrap;font-size:0;pointer-events:none}.ngx-carousel__indicator div{display:inline-block;width:6px;height:6px;margin:0 3px;border-radius:50%;background:rgba(0,0,0,.25);pointer-events:auto}.ngx-carousel__indicator div.active{background:rgba(0,0,0,.75)}"]
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.ChangeDetectorRef }]; }, { loop: [{
            type: Input
        }], speed: [{
            type: Input
        }], autoplay: [{
            type: Input
        }], followFinger: [{
            type: Input
        }], allowTouchMove: [{
            type: Input
        }], initialIndex: [{
            type: Input
        }], change: [{
            type: Output
        }], indicator: [{
            type: Input
        }], track: [{
            type: ViewChild,
            args: ['track', { static: false }]
        }], items: [{
            type: ContentChildren,
            args: [CarouselItemComponent]
        }] }); })();
if (false) {
    /**
     * 是否开启无缝模式
     * @type {?}
     */
    CarouselComponent.prototype.loop;
    /**
     * 切换速度（ms）
     * @type {?}
     */
    CarouselComponent.prototype.speed;
    /**
     * 自动轮播时间间隔，0 代表关闭自动轮播
     * @type {?}
     */
    CarouselComponent.prototype.autoplay;
    /**
     * 是否跟随手指滑动
     * @type {?}
     */
    CarouselComponent.prototype.followFinger;
    /**
     * 是否允许手动滑动，设为 false 代表只能通过 api 翻页
     * @type {?}
     */
    CarouselComponent.prototype.allowTouchMove;
    /**
     * 自定义指示器
     * @type {?}
     */
    CarouselComponent.prototype.indicator;
    /**
     * 默认激活项
     * @type {?}
     */
    CarouselComponent.prototype.initialIndex;
    /**
     * 索引变动时触发
     * @type {?}
     */
    CarouselComponent.prototype.change;
    /** @type {?} */
    CarouselComponent.prototype.track;
    /** @type {?} */
    CarouselComponent.prototype.items;
    /** @type {?} */
    CarouselComponent.prototype.active$;
    /**
     * @type {?}
     * @private
     */
    CarouselComponent.prototype.destroy$;
    /**
     * @type {?}
     * @private
     */
    CarouselComponent.prototype.intervalSub;
    /**
     * @type {?}
     * @private
     */
    CarouselComponent.prototype.percent;
    /**
     * @type {?}
     * @private
     */
    CarouselComponent.prototype.offset;
    /**
     * @type {?}
     * @private
     */
    CarouselComponent.prototype.animating;
    /**
     * @type {?}
     * @private
     */
    CarouselComponent.prototype.preMirrorNode;
    /**
     * @type {?}
     * @private
     */
    CarouselComponent.prototype.postMirrorNode;
    /**
     * @type {?}
     * @private
     */
    CarouselComponent.prototype.render;
    /**
     * @type {?}
     * @private
     */
    CarouselComponent.prototype.hostElRef;
    /**
     * @type {?}
     * @private
     */
    CarouselComponent.prototype.cdr;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/hammer.config.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class HammerConfig extends HammerGestureConfig {
    /**
     * @param {?} element
     * @return {?}
     */
    buildHammer(element) {
        /** @type {?} */
        let mc = new Hammer(element, {
            inputClass: Hammer.TouchMouseInput
        });
        return mc;
    }
}
HammerConfig.ɵfac = /*@__PURE__*/ function () { let ɵHammerConfig_BaseFactory; return function HammerConfig_Factory(t) { return (ɵHammerConfig_BaseFactory || (ɵHammerConfig_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(HammerConfig)))(t || HammerConfig); }; }();
HammerConfig.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: HammerConfig, factory: HammerConfig.ɵfac });


/**
 * @fileoverview added by tsickle
 * Generated from: lib/carousel.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CarouselModule {
}
CarouselModule.ɵfac = function CarouselModule_Factory(t) { return new (t || CarouselModule)(); };
CarouselModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: CarouselModule });
CarouselModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [{ provide: HAMMER_GESTURE_CONFIG, useClass: HammerConfig }], imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CarouselModule, [{
        type: NgModule,
        args: [{
                declarations: [CarouselComponent, CarouselItemComponent, LazyRenderDirective],
                imports: [CommonModule],
                exports: [CarouselComponent, CarouselItemComponent, LazyRenderDirective],
                providers: [{ provide: HAMMER_GESTURE_CONFIG, useClass: HammerConfig }]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CarouselModule, { declarations: function () { return [CarouselComponent, CarouselItemComponent, LazyRenderDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [CarouselComponent, CarouselItemComponent, LazyRenderDirective]; } }); })();

/**
 * @fileoverview added by tsickle
 * Generated from: public-api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: ciri-ngx-carousel.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { CarouselComponent, CarouselItemComponent, CarouselModule, LazyRenderDirective, HammerConfig as ɵa };

